import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#message" }),
    /*#__PURE__*/_createTextVNode(" Message ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Used to show feedback after an activity. The difference with Notification is that the latter is often used to show a system level passive notification. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUITypes = _resolveComponent("EUITypes")
  const _component_EUIClosable = _resolveComponent("EUIClosable")
  const _component_EUICenteredText = _resolveComponent("EUICenteredText")
  const _component_EUIUseHTMLString = _resolveComponent("EUIUseHTMLString")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUITypes),
    _createVNode(_component_EUIClosable),
    _createVNode(_component_EUICenteredText),
    _createVNode(_component_EUIUseHTMLString)
  ], 64))
}